import { render, staticRenderFns } from "./FellingDescriptions.vue?vue&type=template&id=a05bda3e&scoped=true&"
import script from "./FellingDescriptions.vue?vue&type=script&lang=js&"
export * from "./FellingDescriptions.vue?vue&type=script&lang=js&"
import style0 from "./FellingDescriptions.vue?vue&type=style&index=0&id=a05bda3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05bda3e",
  null
  
)

export default component.exports